import React, { useEffect } from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AccessibilityProvider } from "@/components/AccessibilityProvider";
import AccessibilityControls from "@/components/AccessibilityControls";
import Index from "./pages/Index";
import Assessment from "./pages/Assessment";
import Results from "./pages/Results";
import ResultsPage1 from "./pages/ResultsPage1";
import ResultsNextSteps from "./pages/ResultsNextSteps";
import AssessmentComplete from "./pages/AssessmentComplete";
import LiteratureReview from "./pages/LiteratureReview";
import History from "./pages/History";
import Admin from "./pages/Admin";
import Auth from "./pages/Auth";
import AccountSettings from "./pages/AccountSettings";
import DeleteAccountRequest from "./pages/DeleteAccountRequest";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import StoreAssets from "./pages/StoreAssets";
import NotFound from "./pages/NotFound";
import { autoInitializeIfNeeded } from "@/utils/initializeDatabase";
import { initializeMobileApp } from "@/mobile-init";
import Chatbot from "@/components/Chatbot";

const queryClient = new QueryClient();

function App() {
  // Auto-initialize medical database and mobile app on start
  useEffect(() => {
    const initializeApp = async () => {
      await autoInitializeIfNeeded();
      await initializeMobileApp();
    };
    initializeApp();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AccessibilityProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            {/* Skip to main content link for screen readers */}
            <a 
              href="#main-content" 
              className="skip-link"
              aria-label="Skip to main content"
            >
              Skip to main content
            </a>
            
            <div id="main-content" role="main">
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/results" element={<Results />} />
          <Route path="/results/assessment" element={<ResultsPage1 />} />
          <Route path="/results/next-steps" element={<ResultsNextSteps />} />
          <Route path="/results/complete" element={<AssessmentComplete />} />
          <Route path="/results/literature-review" element={<LiteratureReview />} />
          <Route path="/history" element={<History />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/account-settings" element={<AccountSettings />} />
          <Route path="/delete-account-request" element={<DeleteAccountRequest />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/store-assets" element={<StoreAssets />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
            </div>
            
            {/* Accessibility controls */}
            <AccessibilityControls />
            
            {/* Chatbot */}
            <Chatbot />
          </BrowserRouter>
        </TooltipProvider>
      </AccessibilityProvider>
    </QueryClientProvider>
  );
}

export default App;